import {InputBase} from "@mui/material";
import React, {SVGProps, useEffect, useMemo, useRef, useState} from "react";
import {InputBaseProps} from "@mui/material/InputBase/InputBase";
import {AnimatePresence, motion, useMotionValue} from "framer-motion";
import {useWindowStyle} from "../../hooks";
import store, {useTypedSelector} from "../../store";
import {setMachineConnectionState} from "../../store/nodes";
import Tarsy from "./Tarsy";

const psp = (x: number, ff: number) => {
    let xx = 1;
    let c = 0;
    while (c < x) {
        xx *= ff;
        c++;
    }
    return xx
}

let Circle = ({level, delay, rotation, active, ...props}: {level: number, delay?: number, rotation: number, active?: boolean, r?: number, loading?: boolean}) => {
    let r = (props.r || 92) * psp(level, .85);
    let sc = psp(level, .85);
    const num = 32;

    const confusionScale = 80;
    const confusionDuration = 3;
    const confusion = useMemo<[number, number][]>(() => [...Array(num).keys()].map(n => [confusionScale * (Math.random() - .5), confusionScale * (Math.random() - .5)]), [level]);
    const connectionFailed = useTypedSelector(state => state.nodes.machineState.connectionState === 'failed');

    const [l, setL] = useState(0);
    const scale = useMotionValue(0);

    useEffect(() => {
        setL(props.loading ? 1 : 0);
    }, [props.loading])

    return <motion.g
        key={"circle" + level}
        style={{scale}}
        initial={{scale: 0}}
        animate={{
            scale: active ? 1.25 : 1,
            transition: {duration: 1, delay}
        }}
        exit={{scale: 0}}
    >
        {[...Array(num).keys()].map(i => {
            let a = i / num * 2 * Math.PI;
            let scl = (scale.get() - 1) * 4 * l;

            if (scl < 0) scl = 0;
            else if (scl > 1) scl = 1;

            const w = 1.25 * (1 - scl / 2) + scl * (Math.cos(rotation + a) < 0 ? Math.max(0, Math.sin(rotation + a)) : 0) * 1.25;//(inf * Math.cos((rotation * 3.33333 + i) / 36.0 * Math.PI * 10) + (1 - inf) * Math.cos(rotation)) * 4 + 16

            return <motion.circle
                //cx={Math.sin(a) * r}
                //cy={Math.cos(a) * r}
                initial={{
                    x: Math.sin(a) * r,
                    y: Math.cos(a) * r
                }}
                animate={{
                    x: Math.sin(a) * r + (connectionFailed ? confusion[i][0] : 0),
                    y: Math.cos(a) * r + (connectionFailed ? confusion[i][1] : 0),
                    transition: {duration: connectionFailed ? 0 : confusionDuration}
                }}
                r={w * sc}
                fillOpacity={1 - level * .2}
            />
        })}
    </motion.g>
}

const FancyDotAnimation = (props: SVGProps<SVGSVGElement> & {
    onInitialized?: () => any,
    r?: number,
    active?: boolean,
    perspective?: number,
    init?: boolean,
    loading?: boolean
}) => {
    const {onInitialized, r, active, perspective, init, loading, ...svgProps} = props;
    const [rotation, setRotation] = useState<number>(-Math.PI / 2);

    const speed = .12;

    useEffect(() => {
        const interval = setInterval(() => {
            setRotation(r => {
                let rr = r + speed;

                if (r < 2.5 && rr > 2.5) {
                    props.onInitialized && props.onInitialized();
                }

                return rr;
            });
        }, 50);
        return () => clearInterval(interval);
    }, []);

    const circleProps = {r, active, loading, rotation}

    return <svg {...svgProps} viewBox={"0 0 200 200"}>
        {[0, 1, 2, 3].map(l => <Circle key={"circle" + l} {...circleProps} level={l} delay={l * .08}/>)}
        {/*<motion.g style={{scale}} initial={{scale: 0}} animate={{scale: active ? 1.2 : 1, transition: {duration: 1}}}>
            {[...Array(num).keys()].map(i => {
                let a = i / num * 2 * Math.PI;
                const r2 = 0;//20 + Math.sin(rotation) * 20;
                const w = 1.25 + (props.loading ? (Math.cos(rotation + a) < 0 ? Math.max(0, Math.sin(rotation + a)) : 0) * 1.75 : 0);//(inf * Math.cos((rotation * 3.33333 + i) / 36.0 * Math.PI * 10) + (1 - inf) * Math.cos(rotation)) * 4 + 16

                const r_ = props.r || 100;
                const perspective_ = props.perspective || .9;

                let r = r_;
                let perspective = Math.min(1, scale.get()) * perspective_;

                const psp1 = (x: number) => {
                    let xx = 1;
                    let c = 0;
                    while (c < x) {
                        xx *= perspective;
                        c++;
                    }
                    return xx
                }

                const psp2 = (x: number) => {
                    let xx = 1;
                    let c = 0;
                    while (c < x) {
                        xx *= perspective_;
                        c++;
                    }
                    return xx
                }

                const psp = [1, 2, 3, 4].map(x => [psp1(x), psp2(x)])

                return <>
                    <circle
                        cx={Math.sin(a) * (r + r2)}
                        cy={Math.cos(a) * (r + r2)}
                        r={w}
                    />
                    <circle
                        cx={Math.sin(a) * (r * psp[0][0] + r2)}
                        cy={Math.cos(a) * (r * psp[0][0] + r2)}
                        r={w * psp[0][1]}
                        fillOpacity={.9 * psp[0][0]}
                    />
                    <circle
                        cx={Math.sin(a) * (r * psp[1][0] + r2)}
                        cy={Math.cos(a) * (r * psp[1][0] + r2)}
                        r={w * psp[1][1]}
                        fillOpacity={.8 * psp[1][0]}
                    />
                    <circle
                        cx={Math.sin(a) * (r * psp[2][0] + r2)}
                        cy={Math.cos(a) * (r * psp[2][0] + r2)}
                        r={w * psp[2][1]}
                        fillOpacity={.7 * psp[2][0]}
                    />
                    <circle
                        cx={Math.sin(a) * (r * psp[3][0] + r2)}
                        cy={Math.cos(a) * (r * psp[3][0] + r2)}
                        r={w * psp[3][1]}
                        fillOpacity={.6 * psp[3][0]}
                    />
                </>
            })}
        </motion.g>*/}
    </svg>
}

const ConnectedFancyDotAnimation = (props: SVGProps<SVGSVGElement> & {
    onInitialized?: () => any,
    r?: number,
    active?: boolean,
    perspective?: number,
    init?: boolean
}) => {
    const connecting = useTypedSelector(state => state.nodes.machineState.connectionState === 'connecting');
    return <FancyDotAnimation {...props} loading={connecting}/>
}

const ConnectMe = (props: InputBaseProps & {
    onConnected: (url: string) => any
}) => {
    const [hovered, setHovered] = useState<boolean>(false);
    const handleHover = () => setHovered(true);
    const handleUnhover = () => setHovered(false);

    const [value, setValue] = useState<string>("");
    const [focus, setFocus] = useState<[number, number] | undefined>(undefined);

    /*const[on, setOn] = useState<boolean>(!!value || hovered);*/

    const textRef = useRef<HTMLDivElement>(null);
    const style = useWindowStyle();

    const connectionWarning = useTypedSelector(state => state.nodes.machineState.connectionState === "failed" || state.nodes.machineState.connectionState === "successful")

    const [pop, setPop] = useState<boolean>(false);

    useEffect(() => {
        if (connectionWarning) {
            setPop(true);
            setTimeout(() => setPop(false), 100);
        }
    }, [connectionWarning])

    useEffect(() => {
        if (textRef.current && value !== "") {
            let bbox = textRef.current.getBoundingClientRect();
            let x = bbox.left + bbox.width;
            let y = bbox.top + bbox.height / 2;

            setFocus([x, y])
        }
    }, [value]);

    /*useEffect(() => {
        setTimeout(() => setOn(hovered || !!value), 1000)
    }, [value, hovered])*/

    const on = !!value || hovered;

    const exitTransitionStep = [.3333, .5]
    const exitTransition = {delay: exitTransitionStep[0]/*, duration: .5*/}
    const exitTransitionEase = (x: number) => -.333333333333 + 3 * Math.pow(x - .333333333333, 2)

    return <>
        <ConnectedFancyDotAnimation active={on} r={125} fill={"#7088b040"} style={{
            position: 'absolute',
            width: 280,
            height: 280,
            left: "50%",
            top: "50%",
            overflow: "visible"
        }}/>
        <div
            style={{
                position: 'absolute',
                left: "50%",
                top: "50%",
                width: 32,
                height: 32,
                transform: "translate(-50%, -50%)"
            }}
            onMouseOver={handleHover}
            onMouseOut={handleUnhover}
        >
            <motion.div
                style={{
                    position: 'absolute',
                    left: "50%",
                    top: 16,
                    width: 128,
                    height: 128,
                    transform: "translate(-50%, -50%)",
                    pointerEvents: "none"
                }}
                animate={{
                    top: on ? -56 : 16
                }}
                exit={{
                    //top: 16,
                    //transition: exitTransition
                }}
            >
                <motion.div
                    initial={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{delay: exitTransitionStep[1], duration: .5}}
                >
                    <motion.div
                        animate={{scale: pop ? 1.333333 : 1}}
                        exit={{scale: .75, opacity: 0, transition: {duration: .5, ease: exitTransitionEase}}}
                    >
                        <Tarsy focus={focus} ledTrigger={value}/>
                    </motion.div>
                </motion.div>
            </motion.div>
            <motion.div
                style={{
                    position: "absolute",
                    width: 0,
                    height: 24,
                    pointerEvents: 'auto',
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    opacity: 0
                }}
                animate={{
                    width: on ? 200 : 0,
                    opacity: on ? 1 : 0
                }}
                exit={{
                    width: 0,
                    opacity: 0,
                    transition: exitTransition
                }}
            >
                <div style={{
                    position: 'absolute',
                    top: -6,
                    bottom: -6,
                    left: -6 - 12,
                    right: -6 - 12,
                    borderRadius: 18,
                    background: style.window.background,
                    boxShadow: "inset 8px 8px 52px -28px " + style.shadow.color //"inset 8px 8px 40px -4px #00408040"
                }}/>
                <div style={{position: 'absolute', top: -2, left: -4, width: '100%'}}>
                    <InputBase
                        {...props}
                        inputProps={{
                            onMouseDown: (e) => e.stopPropagation(),
                            style: value === "" ? {color: style.palette.default.main} : undefined
                        }}
                        onChange={e => {
                            setValue(e.target.value)
                        }}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                store.dispatch(setMachineConnectionState('connecting'));
                                props.onConnected && props.onConnected(value);
                            }
                        }}
                        fullWidth
                        placeholder={"wss://"}
                        style={{
                            fontFamily: 'Roboto Mono',
                            fontSize: 13,
                            fontWeight: 'bold',
                            lineHeight: '12px',
                            color: style.window.color
                            //background: theme.components.Input.background
                        }}/>
                    <div ref={textRef} style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        fontFamily: 'Roboto Mono',
                        fontSize: 13,
                        pointerEvents: 'none'
                    }}>{value}</div>
                </div>
            </motion.div>
        </div>
    </>
}

const Blocker = () => <div style={{
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'auto',
    display: 'block',
    zIndex: 0
}}/>

const Background = () => {
    let style = useWindowStyle();
    let background = style.mascot.backgroundGradient;

    return <motion.div
        style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background
        }}
        initial={{opacity: 1}}
        exit={{opacity: 0, transition: {delay: .2, duration: 1}}}
    />
}

export default ({onConnected}: {
    onConnected: (url: string) => any
}) => {
    const machineInitialized = useTypedSelector(state => !!state.nodes.machineState.initialized)

    return <AnimatePresence>{!machineInitialized && <>
        <Background/>
        <ConnectMe onConnected={onConnected}/>
    </>}</AnimatePresence>
}